import { Controller } from 'stimulus'
import autosize from 'autosize'

export default class TextareaAutosizeController extends Controller {
  connect() {
    autosize(document.querySelectorAll('textarea.js-autosize'))
  }
}
